module.exports = __webpack_public_path__ + "img/s6_fb_ms.7f388918.png";